import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "featureId", "featureCategoryId", "onClick", "tooltip", "usageTracker", "usageTrackerAppLocationKey", "eventName", "eventProperties"];
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { AIBaseButton } from './internal/AIBaseButton';
import { useTracker } from '../../hooks/useTracker';
import { BREEZE_SPECIAL } from '../../constants/BreezeUse';
import { jsx as _jsx } from "react/jsx-runtime";
const AIButton = _ref => {
  let {
      children,
      featureId,
      featureCategoryId,
      onClick,
      tooltip,
      usageTracker,
      usageTrackerAppLocationKey,
      eventName,
      eventProperties
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    aiTracker
  } = useTracker(usageTracker, usageTrackerAppLocationKey);
  if (props.use === BREEZE_SPECIAL) {
    console.warn('BREEZE_SPECIAL is not meant for external use. Please use a different use type.');
  }
  const handleClick = event => {
    if (onClick) {
      onClick(event);
      if (aiTracker) {
        aiTracker.track('aiButtonInteraction', {
          type: 'trigger',
          featureId,
          featureCategoryId
        });
        // Custom tracking
        if (eventName && eventProperties) {
          aiTracker.track(eventName, eventProperties);
        }
      }
    }
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip,
    children: /*#__PURE__*/_jsx(AIBaseButton, Object.assign({}, props, {
      "data-test-id": props['data-test-id'] || 'ai-button',
      onClick: handleClick,
      children: children
    }))
  });
};
export default AIButton;